<template>
  <div>
    <v-tabs v-model="tab" centered icons-and-text>
      <v-tab
        v-for="(video) in value"
        :key="`previews-video-tab-${video.name}`"
        @click="selected=video"
      >
        {{video.name}}
        <v-icon>{{video.icon}}</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item eager v-for="(video) in value" :key="`previews-video-tab-${video.name}`">
        <video-preview :value="video.video"></video-preview>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import videoPreview from "./video";

export default {
  name: "PagePreviewVideos",
  props: ["value"],
  computed: {},
  components: {
    videoPreview
  },
  data() {
    return {
      tab: null,
      selected: null
    };
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  /* xs */
  .v-slide-group__prev {
    min-width: 0px !important;
  }
  .v-slide-group__next {
    min-width: 0px !important;
  }

  .v-tab {
    font-size: 0.7rem;
    min-width: 0px;
    padding: 0 5px;
  }
}
@media only screen and (max-width: 960px) and (min-width: 600px) {
  /* sm */
  .v-slide-group__prev {
    min-width: 0px !important;
  }
  .v-slide-group__next {
    min-width: 0px !important;
  }

  .v-tab {
    font-size: 0.7rem;
    min-width: 0px;
    padding: 0 10px;
  }
}
</style>
